// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Package/components/ProductThumbnail/index.css
// module id = 2324
// module chunks = 0